// The frame of a normal screen: a toolbar with the menu button, the preview
// banner, and a content column.
import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import type { ReactNode } from "react";
import { PreviewBanner } from "../design";
import { useMe } from "../api/live";

export function Page({ title, children, actions, narrow }: { title: string; children: ReactNode; actions?: ReactNode; narrow?: boolean }) {
  const { me } = useMe();
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start"><IonMenuButton /></IonButtons>
          <IonTitle>{title}</IonTitle>
          {actions ? <IonButtons slot="end">{actions}</IonButtons> : null}
        </IonToolbar>
        <PreviewBanner preview={me?.preview} />
      </IonHeader>
      <IonContent>
        <div className={`page${narrow ? " page--narrow" : ""}`}>{children}</div>
      </IonContent>
    </IonPage>
  );
}
